var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticStyle: { height: "50px" }, attrs: { height: "50px" } },
    [
      _vm.directoryItem.id < 0 && _vm.filterIndexByContact(_vm.directoryItem)
        ? _c(
            "h3",
            {
              staticClass: "d-flex align-center white--text subheader",
              staticStyle: { height: "44px" },
              attrs: { height: "44px" }
            },
            [
              _c("span", { staticClass: "ml-3" }, [
                _vm._v(_vm._s(_vm.directoryItem.name))
              ])
            ]
          )
        : _vm._e(),
      _vm.directoryItem.id > 0 &&
      (_vm.filterByContact(_vm.directoryItem.name.split(", ")[0]) ||
        _vm.filterByContact(_vm.directoryItem.name.split(", ")[1]))
        ? _c(
            "span",
            { staticStyle: { height: "50px" }, attrs: { height: "50px" } },
            [
              _c(
                "v-list-item",
                {
                  staticStyle: { height: "50px" },
                  attrs: { height: "50px", disabled: _vm.isSelectedProp },
                  on: {
                    click: function($event) {
                      return _vm.emitContact(_vm.directoryItem)
                    }
                  }
                },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mr-n3",
                                  staticStyle: { "z-index": "2" },
                                  attrs: { cols: "10" }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.directoryItem.name) + " "
                                  )
                                ]
                              ),
                              _vm.directoryItem.adminUser
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-6 mt-n8",
                                          attrs: { color: "green" }
                                        },
                                        [_vm._v("mdi-check-all")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider")
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }